<!--选择城市-->
<template>
  <div>
    <div class="point-btn" :class="isMore?'move':''" @click="open">
      <img
          class="point-btn-icon"
          :src="
            $config.host + '/image/index-new-point/point-btn.png'
          "
        />
    </div>
    <div class="home-new-point" v-if="isShow">
      <div class="point-step-content">
        <img
          class="point-step-icon"
          :src="
            $config.host + '/image/index-new-point/point-' + active + '.png'
          "
        />
      </div>
      <div class="point-step-box">
        <div class="point-step-flex" @click="prve"></div>
        <div class="point-step-flex" @click="next"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pi-home-new-point",
  props: {
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 1,
      isShow: false,
    };
  },
  methods: {
    open(){
      this.active = 1;
      this.isShow = true;
    },
    close(){
      this.isShow = false;
    },
    next() {
      if (this.active < 6) {
        this.active++;
      } else {
        this.close();
      }
    },
    prve() {
      if (this.active == 6) {
        this.active = 1;
      } else{
        this.close();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-new-point {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  .point-step-content {
    .point-step-icon {
      width: 100%;
    }
  }
  .point-step-box {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    display: flex;
    height: 100%;
    .point-step-flex {
      flex: 1;
    }
  }
}
.point-btn{
  position: fixed;
  width: 1.1rem;
  height: 1.1rem;
  left: 0.1rem;
  bottom: 3.13rem;
  .point-btn-icon{
    width: 100%;
    height: 100%;
  }
}
.point-btn.move{
  bottom: 5.28rem;
}
</style>
